// Utility functions for date formatting

/**
 * Converts date from YYYY-MM-DD to MM-DD-YYYY
 * @param {string} dateStr - Date string in YYYY-MM-DD format
 * @returns {string} Date string in MM-DD-YYYY format
 */
export const formatDateToUS = (dateStr) => {
  if (!dateStr) return '';
  
  // Check if already in MM-DD-YYYY format
  if (dateStr.match(/^\d{2}-\d{2}-\d{4}$/)) {
    return dateStr;
  }
  
  // Convert from YYYY-MM-DD to MM-DD-YYYY
  if (dateStr.match(/^\d{4}-\d{2}-\d{2}$/)) {
    const [year, month, day] = dateStr.split('-');
    return `${month}-${day}-${year}`;
  }
  
  return dateStr;
};

/**
 * Converts date from MM-DD-YYYY to YYYY-MM-DD
 * @param {string} dateStr - Date string in MM-DD-YYYY format
 * @returns {string} Date string in YYYY-MM-DD format
 */
export const formatDateToISO = (dateStr) => {
  if (!dateStr) return '';
  
  // Check if already in YYYY-MM-DD format
  if (dateStr.match(/^\d{4}-\d{2}-\d{2}$/)) {
    return dateStr;
  }
  
  // Convert from MM-DD-YYYY to YYYY-MM-DD
  if (dateStr.match(/^\d{2}-\d{2}-\d{4}$/)) {
    const [month, day, year] = dateStr.split('-');
    return `${year}-${month}-${day}`;
  }
  
  return dateStr;
};
